import { useSelector } from 'react-redux';
import { USER_MODE } from '../data/userModeConstants';

export const useShouldSelectBranch = function() {
  const shop = useSelector(state => state.auth.shop);
  const user = useSelector(state => state.auth.user);

  if (!user) return false;
  else if (user.mode !== USER_MODE.CUSTOMER && user.isGlobalAdmin) return false;
  else if (user.mode === USER_MODE.CUSTOMER && user.loggedInBranch) return false;

  return shop && shop.maxNumberOfBranches && !user.loggedInBranch;
};
